import { render } from "./MouseDebug.vue?vue&type=template&id=0968bd72&scoped=true"
import script from "./MouseDebug.vue?vue&type=script&lang=js"
export * from "./MouseDebug.vue?vue&type=script&lang=js"

import "./MouseDebug.vue?vue&type=style&index=0&id=0968bd72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0968bd72"]])

export default __exports__